<template>
  <div class="wk-text"> {{ text }}</div>
</template>

<script>
export default {
  name: 'WkText',
  props: {
    text: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
.wk-text {
    color: #333;font-size:12px
}
</style>